import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, filter, map, switchMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { AuthModule, OidcSecurityService } from 'angular-auth-oidc-client';
import * as UserActions from './user.actions';
import { ILanguageValue } from 'app/core/services/i18n/models/ILanguageValue';
import { I18nService } from 'app/core/services/i18n/i18n.service';
import { IUser } from '../models/IUser';
import { CldrIntlService, IntlService } from '@progress/kendo-angular-intl';

@Injectable()
export class UserEffects {
  constructor(
    private actions$: Actions,
    private oidcSecurityService: OidcSecurityService,
    private i18n: I18nService,
    private intlService: IntlService,
  ) {}

  loadUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserActions.loadUser),
      switchMap(() =>
        this.oidcSecurityService.userData$.pipe(
          tap((userData: any) => {
            // Check if we have user data in the nested structure
            if (userData?.userData) {
              const currentLang: ILanguageValue = this.i18n.supportedUIUserLanguages.find(
                lang => lang.CultureCode.toLowerCase() === userData.userData.culture?.toLowerCase(),
              );
              if (currentLang !== null) {
                this.i18n.CurrentUILanguage = currentLang;
                (<CldrIntlService>this.intlService).localeId = currentLang.CultureCode;
              }
            }
          }),
          map((userData: any) => {
            // Handle the case where userData.userData is null
            const actualUserData = userData?.userData || {};
            return UserActions.loadUserSuccess({ userData: actualUserData });
          }),
          catchError(error => {
            console.error('User loading error:', error);
            return of(UserActions.loadUserError({ error }));
          })
        )
      )
    )
  );
}
